/* NDW v2 — Build a Box (Skio dynamic build-a-box) */
(function () {
  "use strict";

  var API = "https://api.skio.com/storefront-http/get-dynamic-box";
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var CHECK_THIN = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3 4.5 8.5 2 6"/></svg>';
  var MINUS = '<svg viewBox="0 0 21 21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 10.5H13.5"/></svg>';
  var PLUS = '<svg viewBox="0 0 21 21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 10.5H13.5"/><path d="M10.5 7.5v6"/></svg>';

  function gidToId(gid) { return String(gid || "").split("/").pop(); }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(amount);
    } catch (e) {
      return "$" + Number(amount || 0).toFixed(2);
    }
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function BuildABox(root) {
    this.root = root;
    this.productId = root.getAttribute("data-product-id");
    this.currency = "USD";
    this.box = null;
    this.min = 2;
    this.max = 6;
    this.displayMax = 6;
    this.hasHardMax = true;
    this.tiers = {};
    this.frequencies = [];
    this.plan = "subscribe";
    this.freqPlanId = null;
    this.selections = {}; // productId -> { product, variant }

    this.dom = {
      grid: root.querySelector("[data-bab-grid]"),
      ladder: root.querySelector("[data-bab-ladder]"),
      ladderNote: root.querySelector("[data-bab-ladder-note]"),
      countLabel: root.querySelector("[data-bab-count-label]"),
      countPill: root.querySelector("[data-bab-count-pill]"),
      statusTitle: root.querySelector("[data-bab-status-title]"),
      statusSub: root.querySelector("[data-bab-status-sub]"),
      segments: root.querySelector("[data-bab-segments]"),
      items: root.querySelector("[data-bab-items]"),
      totals: root.querySelector("[data-bab-totals]"),
      freq: root.querySelector("[data-bab-freq]"),
      freqWrap: root.querySelector("[data-bab-freq-wrap]"),
      subBadge: root.querySelector("[data-bab-sub-badge]"),
      cta: root.querySelector("[data-bab-cta]")
    };

    this.bindStatic();
    this.load();
  }

  BuildABox.prototype.bindStatic = function () {
    var self = this;
    this.root.querySelectorAll("[data-bab-opt]").forEach(function (opt) {
      opt.addEventListener("click", function (e) {
        if (e.target.closest("[data-bab-freq-wrap]")) return; // don't toggle when using the dropdown
        self.plan = opt.getAttribute("data-bab-opt");
        self.syncPurchaseUI();
        self.renderSummary();
      });
    });
    if (this.dom.freq) {
      this.dom.freq.addEventListener("change", function () {
        self.freqPlanId = self.dom.freq.value;
        self.renderSummary();
      });
    }
    if (this.dom.cta) {
      this.dom.cta.addEventListener("click", function () { self.addToCart(); });
    }
  };

  BuildABox.prototype.load = function () {
    var self = this;
    fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productPlatformId: this.productId })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var box = data && (data.DynamicBox || data.dynamicBox || data.box);
        if (!data || data.ok === false || !box) throw new Error("No box");
        self.setup(box);
      })
      .catch(function (err) {
        console.error("[build-a-box]", err);
        self.root.classList.remove("is-loading");
        if (self.dom.ladder) self.dom.ladder.innerHTML = "";
        if (self.dom.segments) self.dom.segments.innerHTML = "";
        if (self.dom.ladderNote) self.dom.ladderNote.textContent = "";
        if (self.dom.grid) {
          self.dom.grid.innerHTML = '<div class="bab__error">Bundle builder could not load. Please refresh the page.</div>';
        }
      });
  };

  BuildABox.prototype.setup = function (box) {
    this.box = box;
    this.currency = box.currencyCode || "USD";
    this.tiers = box.percentDiscountTier || {};

    var range = box.sizeRange || [2, 6];
    this.min = range[0];
    this.max = range[range.length - 1];

    var tierKeys = Object.keys(this.tiers).map(Number);
    var maxTier = tierKeys.length ? Math.max.apply(null, tierKeys) : this.max;
    this.hasHardMax = this.max <= 24;
    this.displayMax = this.hasHardMax ? this.max : maxTier;

    var spg = box.sellingPlanGroup || {};
    this.frequencies = Object.keys(spg).map(function (planId) {
      var p = spg[planId];
      return {
        planId: planId,
        title: p.title || "Every " + p.intervalCount + " " + p.interval,
        position: p.position || 0,
        amount: p.priceAdjustmentAmount || 0
      };
    }).sort(function (a, b) { return a.position - b.position; });
    if (this.frequencies.length) this.freqPlanId = this.frequencies[0].planId;

    this.renderFrequencies();
    this.renderLadder();
    this.renderSegments();
    this.renderProducts();
    this.syncPurchaseUI();
    this.renderSummary();
    this.root.classList.remove("is-loading");
  };

  /* ---------- Renderers ---------- */

  BuildABox.prototype.renderFrequencies = function () {
    if (this.dom.freq) {
      var self = this;
      this.dom.freq.innerHTML = "";
      this.frequencies.forEach(function (f) {
        var opt = document.createElement("option");
        opt.value = f.planId;
        opt.textContent = f.title;
        self.dom.freq.appendChild(opt);
      });
    }
    var amt = this.frequencies[0] && this.frequencies[0].amount;
    if (this.dom.subBadge && amt) this.dom.subBadge.textContent = "Save " + amt + "%";
  };

  BuildABox.prototype.tierCounts = function () {
    return Object.keys(this.tiers).map(Number).sort(function (a, b) { return a - b; });
  };

  BuildABox.prototype.renderLadder = function () {
    if (!this.dom.ladder) return;
    var counts = this.tierCounts();
    this.dom.ladder.innerHTML = "";
    var self = this;
    counts.forEach(function (c, i) {
      var step = el("div", "bab__step");
      step.setAttribute("data-step", c);
      var row = el("div", "bab__step-row");
      row.appendChild(el("span", "bab__line bab__line--l" + (i === 0 ? " bab__line--hidden" : "")));
      row.appendChild(el("span", "bab__dot", CHECK_THIN));
      row.appendChild(el("span", "bab__line bab__line--r" + (i === counts.length - 1 ? " bab__line--hidden" : "")));
      step.appendChild(row);
      var label = el("div", "bab__step-label");
      label.appendChild(el("span", "bab__step-count", c + " items"));
      label.appendChild(el("span", "bab__step-off", self.tiers[c] + "% off"));
      step.appendChild(label);
      self.dom.ladder.appendChild(step);
    });
  };

  BuildABox.prototype.renderSegments = function () {
    if (!this.dom.segments) return;
    this.dom.segments.innerHTML = "";
    for (var i = 0; i < this.displayMax; i++) {
      this.dom.segments.appendChild(el("i", null, CHECK + '<span class="bab__seg-num">' + (i + 1) + "</span>"));
    }
  };

  function babFlavorOf(title) { title = String(title || ""); var i = title.indexOf("/"); return (i >= 0 ? title.slice(i + 1) : title).trim(); }
  function babSupplyOf(title) { title = String(title || ""); var i = title.indexOf("/"); return (i >= 0 ? title.slice(0, i) : title).trim(); }

  BuildABox.prototype.flavorHandleSet = function () {
    if (this._flavorSet) return this._flavorSet;
    var set = {};
    (this.root.getAttribute("data-flavor-handles") || "").split(",").forEach(function (h) {
      h = h.trim();
      if (h) set[h] = true;
    });
    this._flavorSet = set;
    return set;
  };

  BuildABox.prototype.renderProducts = function () {
    var self = this;
    var products = this.box.selectableProductVariants || [];
    var flavorSet = this.flavorHandleSet();
    this.dom.grid.innerHTML = "";

    products.forEach(function (p) {
      var variants = p.productVariants || [];
      // Flavor products (hydration): one card per flavor, supply picked inside.
      if (flavorSet[p.productHandle] && variants.length > 1) {
        var order = [], groups = {};
        variants.forEach(function (v) {
          var f = babFlavorOf(v.productVariantTitle);
          if (!groups[f]) { groups[f] = []; order.push(f); }
          groups[f].push(v);
        });
        order.forEach(function (f) { self.dom.grid.appendChild(self.buildCard(p, groups[f], f)); });
      } else {
        self.dom.grid.appendChild(self.buildCard(p, variants, null));
      }
    });
  };

  BuildABox.prototype.buildCard = function (p, variants, flavorLabel) {
    var self = this;
    var isFlavor = !!flavorLabel;
    var card = el("div", "bab-card");

    var media = el("div", "bab-card__media is-loading");
    var img = document.createElement("img");
    img.loading = "lazy";
    var clearLoading = function () {
      media.classList.remove("is-loading");
      img.classList.add("is-loaded");
    };
    img.addEventListener("load", clearLoading);
    img.addEventListener("error", clearLoading);
    var skioImg = (variants[0] && variants[0].imageSrc) || p.productImageSrc || "";
    img.alt = (isFlavor ? p.productTitle + " — " + flavorLabel : p.productTitle) || "";
    media.appendChild(img);
    media.appendChild(el("span", "bab-card__check", CHECK_THIN));
    card.appendChild(media);

    var body = el("div", "bab-card__body");
    // flavor cards: product name + flavor together in the title (wraps naturally)
    var titleEl = el("h3", "bab-card__title");
    titleEl.textContent = isFlavor ? (p.productTitle + " " + flavorLabel) : (p.productTitle || "");
    body.appendChild(titleEl);
    if (!isFlavor && (p.subtitle || p.description)) {
      body.appendChild(el("p", "bab-card__desc", p.subtitle || p.description));
    }

    // everything from the select down is bottom-anchored so controls line up
    // across cards regardless of title height
    var foot = el("div", "bab-card__foot");

    var select = el("select", "bab-card__variant");
    // show sizes cheapest → most expensive; the smallest becomes the default
    var sortedVariants = variants.slice().sort(function (a, b) { return (a.price || 0) - (b.price || 0); });
    sortedVariants.forEach(function (v, i) {
      var opt = document.createElement("option");
      opt.value = v.platformId;
      // flavor cards: the select is the supply/size (label without the flavor part)
      opt.textContent = isFlavor ? babSupplyOf(v.productVariantTitle) : v.productVariantTitle;
      if (i === 0) opt.selected = true;
      select.appendChild(opt);
    });
    if (variants.length > 1) foot.appendChild(select);

    var priceRow = el("div", "bab-card__price");
    foot.appendChild(priceRow);

    var addBtn = el("button", "bab-card__add", "Add to Bundle");
    addBtn.type = "button";
    foot.appendChild(addBtn);

    var added = el("div", "bab-card__added");
    added.appendChild(el("span", "bab-card__added-label", CHECK_THIN + "<span>Added</span>"));
    var qty = el("div", "bab-card__qty");
    var minusBtn = el("button", "bab-card__qty-btn bab-card__qty-btn--minus", MINUS);
    minusBtn.type = "button";
    minusBtn.setAttribute("aria-label", "Decrease quantity");
    var qtyNum = el("span", "bab-card__qty-num", "1");
    var plusBtn = el("button", "bab-card__qty-btn bab-card__qty-btn--plus", PLUS);
    plusBtn.type = "button";
    plusBtn.setAttribute("aria-label", "Increase quantity");
    qty.appendChild(minusBtn);
    qty.appendChild(qtyNum);
    qty.appendChild(plusBtn);
    added.appendChild(qty);
    foot.appendChild(added);

    var removeBtn = el("button", "bab-card__remove", "Remove from bundle");
    removeBtn.type = "button";
    foot.appendChild(removeBtn);

    body.appendChild(foot);
    card.appendChild(body);

    var activeVariant = function () { return self.variantById(variants, select.value) || variants[0]; };
    var updatePrice = function () { self.paintPrice(priceRow, activeVariant()); };
    updatePrice();
    if (isFlavor) {
      // flavor image is variant-specific; use it directly (no per-product bab-img override)
      if (skioImg) img.src = skioImg;
    } else {
      self.applyPlpImage(p, img, skioImg); // same image as the PLP; fixed regardless of variant
    }

    // the card mirrors the currently-selected variant: switching to an
    // un-added variant shows "Add to Bundle" again, an added one shows the stepper.
    select.addEventListener("change", function () {
      updatePrice();
      self.renderCardsState();
    });
    addBtn.addEventListener("click", function () { self.addVariant(p, activeVariant()); });
    minusBtn.addEventListener("click", function () { self.changeQty(activeVariant().platformId, -1); });
    plusBtn.addEventListener("click", function () { self.changeQty(activeVariant().platformId, 1); });
    removeBtn.addEventListener("click", function () { self.remove(activeVariant().platformId); });

    card._ctx = { activeVariant: activeVariant, product: p, qtyNum: qtyNum, plusBtn: plusBtn, addBtn: addBtn, card: card };
    return card;
  };

  BuildABox.prototype.imageForVariant = function (product, variant) {
    return product._img || (variant && variant.imageSrc) || product.productImageSrc || "";
  };

  BuildABox.prototype.applyPlpImage = function (product, imgEl, fallback) {
    var setSrc = function (url) { if (imgEl && url) imgEl.src = url; };
    var handle = product.productHandle;
    if (!handle) { setSrc(fallback); return; }
    // Same image the PLP uses: custom.collection_product_image metafield, else
    // first gallery image, else featured — resolved by the bab-img template.
    // We wait for this before showing anything (shimmer meanwhile) so the image
    // appears once, correct — no swap from the Skio image.
    fetch("/products/" + handle + "?view=bab-img")
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (t) {
        var url = (t || "").trim();
        if (url && url.indexOf("<") === -1) {
          if (url.indexOf("//") === 0) url = "https:" + url;
          // accept absolute (http…) or root-relative (/cdn/…, dev server) URLs
          if (url.charAt(0) === "/" || url.indexOf("http") === 0) {
            product._img = url;
            setSrc(url);
            return;
          }
        }
        setSrc(fallback); // bab-img unusable → fall back to the Skio image
      })
      .catch(function () { setSrc(fallback); });
  };

  BuildABox.prototype.paintPrice = function (row, v) {
    row.innerHTML = "";
    row.appendChild(el("b", null, money(v.price, this.currency)));
    if (v.compareAtPrice && v.compareAtPrice > v.price) {
      row.appendChild(el("span", "bab-card__compare", money(v.compareAtPrice, this.currency)));
    }
  };

  /* ---------- Selection ---------- */

  BuildABox.prototype.variantById = function (variants, platformId) {
    for (var i = 0; i < variants.length; i++) if (variants[i].platformId === platformId) return variants[i];
    return null;
  };

  // total units in the bundle (sum of per-variant quantities)
  BuildABox.prototype.count = function () {
    var n = 0;
    for (var vid in this.selections) n += this.selections[vid].qty;
    return n;
  };

  // keyed by variant platformId so the same product can be added multiple
  // times with different variants (flavor / size) as separate lines.
  BuildABox.prototype.addVariant = function (product, variant) {
    var vid = variant.platformId;
    if (this.selections[vid]) return;
    if (this.count() >= this.max) return;
    this.selections[vid] = { product: product, variant: variant, qty: 1 };
    this.afterChange();
  };

  BuildABox.prototype.changeQty = function (vid, delta) {
    var sel = this.selections[vid];
    if (!sel) return;
    if (delta > 0 && this.count() >= this.max) return; // bundle already full
    var q = sel.qty + delta;
    if (q < 1) { this.remove(vid); return; }
    sel.qty = q;
    this.afterChange();
  };

  BuildABox.prototype.remove = function (vid) {
    delete this.selections[vid];
    this.afterChange();
  };

  BuildABox.prototype.afterChange = function () {
    this.renderSummary();
    this.renderCardsState();
  };

  BuildABox.prototype.renderCardsState = function () {
    var self = this;
    var atMax = this.count() >= this.max;
    this.dom.grid.querySelectorAll(".bab-card").forEach(function (card) {
      var ctx = card._ctx;
      if (!ctx) return;
      var sel = self.selections[ctx.activeVariant().platformId];
      var added = !!sel;
      card.classList.toggle("is-added", added);
      if (added) {
        ctx.qtyNum.textContent = sel.qty;
        ctx.plusBtn.disabled = atMax;
      }
      ctx.addBtn.disabled = !added && atMax;
    });
  };

  /* ---------- Summary ---------- */

  BuildABox.prototype.currentTier = function () {
    var count = this.count(), pct = 0;
    this.tierCounts().forEach(function (c) { if (count >= c) pct = Number(this.tiers[c]); }, this);
    return pct;
  };

  BuildABox.prototype.nextTier = function () {
    var count = this.count(), keys = this.tierCounts();
    for (var i = 0; i < keys.length; i++) if (keys[i] > count) return { count: keys[i], pct: Number(this.tiers[keys[i]]) };
    return null;
  };

  BuildABox.prototype.renderSummary = function () {
    var count = this.count(), min = this.min, max = this.max;
    var label = this.hasHardMax ? count + "/" + this.displayMax : String(count);
    if (this.dom.countLabel) this.dom.countLabel.textContent = label + " selected";
    if (this.dom.countPill) this.dom.countPill.textContent = label;

    // segments
    if (this.dom.segments) {
      var segs = this.dom.segments.children;
      for (var i = 0; i < segs.length; i++) segs[i].classList.toggle("is-filled", i < count);
    }

    // status
    var next = this.nextTier();

    // ladder active state (reached = filled+check, current = next tier ring)
    if (this.dom.ladder) {
      var currentStep = next ? next.count : null;
      this.dom.ladder.querySelectorAll(".bab__step").forEach(function (s) {
        var c = Number(s.getAttribute("data-step"));
        s.classList.toggle("is-reached", count >= c);
        s.classList.toggle("is-current", currentStep !== null && c === currentStep);
      });
    }


    if (this.dom.statusTitle && this.dom.statusSub) {
      if (count < min) {
        var optional = max - min;
        this.dom.statusTitle.textContent = count + " of " + min + " required items added";
        this.dom.statusSub.textContent = "Add up to " + optional + " more optional items for bigger savings.";
      } else if (count >= max) {
        this.dom.statusTitle.textContent = "Bundle full";
        this.dom.statusSub.textContent = "You've unlocked the maximum discount.";
      } else {
        this.dom.statusTitle.textContent = "Bundle ready";
        this.dom.statusSub.textContent = "You can checkout now or add more for bigger savings";
      }
    }
    if (this.dom.ladderNote) {
      if (count < min) {
        var n = min - count;
        this.dom.ladderNote.textContent = "Add " + n + " " + (n === 1 ? "item" : "items") + " to start your bundle.";
      } else if (next) {
        var d = next.count - count;
        this.dom.ladderNote.textContent =
          "You're ready to checkout. Add " + d + " more " + (d === 1 ? "item" : "items") + " to unlock " + next.pct + "% off.";
      } else {
        this.dom.ladderNote.textContent = "You're saving " + this.currentTier() + "% — the biggest bundle discount.";
      }
    }

    this.renderItems();
    this.renderTotals();
    this.renderCTA();
  };

  BuildABox.prototype.renderItems = function () {
    var box = this.dom.items;
    if (!box) return;
    box.innerHTML = "";
    var pids = Object.keys(this.selections);

    if (!pids.length) {
      var empty = el("div", "bab__empty");
      empty.appendChild(el("div", "bab__empty-icon",
        '<svg viewBox="0 0 17 17" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6.37497 15.1584C6.92265 15.1584 7.36663 14.7144 7.36663 14.1667C7.36663 13.619 6.92265 13.175 6.37497 13.175C5.82729 13.175 5.3833 13.619 5.3833 14.1667C5.3833 14.7144 5.82729 15.1584 6.37497 15.1584Z"/><path d="M12.75 15.1584C13.2976 15.1584 13.7416 14.7144 13.7416 14.1667C13.7416 13.619 13.2976 13.175 12.75 13.175C12.2023 13.175 11.7583 13.619 11.7583 14.1667C11.7583 14.7144 12.2023 15.1584 12.75 15.1584Z"/><path d="M1.4165 2.125H2.97484L4.53317 10.7667C4.58323 11.0291 4.7244 11.2655 4.93177 11.4339C5.13913 11.6024 5.39936 11.6922 5.6665 11.6875H11.7582C12.0253 11.6922 12.2855 11.6024 12.4929 11.4339C12.7003 11.2655 12.8414 11.0291 12.8915 10.7667L14.1665 4.95833H3.68317"/></svg>'));
      empty.appendChild(el("b", null, "No items yet."));
      empty.appendChild(el("span", null, "Select products from the grid."));
      box.appendChild(empty);
      return;
    }

    var self = this;
    var atMax = this.count() >= this.max;
    pids.forEach(function (pid) {
      var sel = self.selections[pid];
      var row = el("div", "bab__item");

      var img = document.createElement("img");
      img.className = "bab__item-img";
      img.loading = "lazy";
      img.src = self.imageForVariant(sel.product, sel.variant);
      img.alt = sel.product.productTitle;
      row.appendChild(img);

      var info = el("div", "bab__item-info");
      info.appendChild(el("b", null, sel.product.productTitle));
      info.appendChild(el("small", null, sel.variant.productVariantTitle));
      row.appendChild(info);

      var qty = el("div", "bab__item-qty");
      var minusBtn = el("button", "bab__item-minus", MINUS);
      minusBtn.type = "button";
      minusBtn.setAttribute("aria-label", "Decrease quantity");
      var qtyNum = el("span", null, String(sel.qty));
      var plusBtn = el("button", "bab__item-plus", PLUS);
      plusBtn.type = "button";
      plusBtn.setAttribute("aria-label", "Increase quantity");
      plusBtn.disabled = atMax;
      qty.appendChild(minusBtn);
      qty.appendChild(qtyNum);
      qty.appendChild(plusBtn);
      minusBtn.addEventListener("click", function () { self.changeQty(pid, -1); });
      plusBtn.addEventListener("click", function () { self.changeQty(pid, 1); });
      row.appendChild(qty);

      row.appendChild(el("span", "bab__item-price", money(sel.variant.price * sel.qty, self.currency)));

      var rm = el("button", "bab__item-remove",
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>');
      rm.type = "button";
      rm.setAttribute("aria-label", "Remove item");
      rm.addEventListener("click", function () { self.remove(pid); });
      row.appendChild(rm);

      box.appendChild(row);
    });
  };

  BuildABox.prototype.priceForItem = function (variant) {
    if (this.plan === "subscribe" && this.freqPlanId) {
      var g = (this.box.sellingPlanGroup || {})[this.freqPlanId];
      var m = g && g.variantMapping && g.variantMapping[variant.platformId];
      if (m && typeof m.adjustedPrice === "number") return m.adjustedPrice;
    }
    return variant.price;
  };

  // subtotal after subscription adjustment (regular price for one-time)
  BuildABox.prototype.subtotal = function () {
    var sum = 0;
    for (var pid in this.selections) {
      var sel = this.selections[pid];
      sum += this.priceForItem(sel.variant) * sel.qty;
    }
    return sum;
  };

  // subtotal at full/regular price, before any discount
  BuildABox.prototype.regularSubtotal = function () {
    var sum = 0;
    for (var pid in this.selections) {
      var sel = this.selections[pid];
      sum += sel.variant.price * sel.qty;
    }
    return sum;
  };

  BuildABox.prototype.subscribePercent = function () {
    for (var i = 0; i < this.frequencies.length; i++) {
      if (this.frequencies[i].planId === this.freqPlanId) return this.frequencies[i].amount;
    }
    return 0;
  };

  BuildABox.prototype.renderTotals = function () {
    var box = this.dom.totals;
    if (!box) return;
    if (!this.count()) { box.innerHTML = ""; return; }

    var regular = this.regularSubtotal();
    var afterSub = this.subtotal();
    var subDiscount = regular - afterSub;
    var tier = this.currentTier();
    var bundleDiscount = afterSub * (tier / 100);
    var total = afterSub - bundleDiscount;
    var subscribe = this.plan === "subscribe";

    var mk = function (cls, a, b) {
      var r = el("div", "row" + (cls ? " " + cls : ""));
      r.appendChild(el("span", null, a));
      r.appendChild(el("span", null, b));
      return r;
    };

    var inner = el("div", "bab__totals-box");
    inner.appendChild(mk("bab__sub-row", "Subtotal", money(regular, this.currency)));
    if (tier > 0) {
      inner.appendChild(mk("bab__disc-row", "Bundle discount (" + tier + "% off)", "-" + money(bundleDiscount, this.currency)));
    }
    if (subscribe && subDiscount > 0.005) {
      inner.appendChild(mk("bab__disc-row", "Subscribe & Save (" + this.subscribePercent() + "% off)", "-" + money(subDiscount, this.currency)));
    }
    inner.appendChild(el("div", "bab__totals-divider"));
    inner.appendChild(mk("bab__total-row", "Estimated total", money(total, this.currency)));

    box.innerHTML = "";
    box.appendChild(inner);
  };

  BuildABox.prototype.renderCTA = function () {
    var cta = this.dom.cta;
    if (!cta) return;
    var count = this.count();
    var ready = count >= this.min;
    cta.classList.toggle("is-ready", ready);
    cta.disabled = !ready;
    if (!ready) {
      cta.textContent = "Add at least " + this.min + " items";
    } else {
      cta.textContent = "Add to cart";
    }
  };

  BuildABox.prototype.syncPurchaseUI = function () {
    var self = this;
    this.root.querySelectorAll("[data-bab-opt]").forEach(function (opt) {
      var active = opt.getAttribute("data-bab-opt") === self.plan;
      opt.classList.toggle("is-active", active);
      var input = opt.querySelector("input");
      if (input) input.checked = active;
    });
    if (this.dom.freqWrap) this.dom.freqWrap.style.display = this.plan === "subscribe" ? "" : "none";
  };

  /* ---------- Cart ---------- */

  BuildABox.prototype.planIdForVariant = function (variantGid) {
    if (this.plan !== "subscribe" || !this.freqPlanId) return null;
    var g = (this.box.sellingPlanGroup || {})[this.freqPlanId];
    var m = g && g.variantMapping && g.variantMapping[variantGid];
    return gidToId((m && m.planId) || this.freqPlanId);
  };

  BuildABox.prototype.addToCart = function () {
    var self = this;
    if (this.count() < this.min) return;

    var items = Object.keys(this.selections).map(function (pid) {
      var sel = self.selections[pid];
      var item = {
        id: Number(gidToId(sel.variant.platformId)),
        quantity: sel.qty,
        properties: { _dynamicBoxId: self.box.boxId, _dynamicBoxIndex: 0 }
      };
      var planId = self.planIdForVariant(sel.variant.platformId);
      if (planId) item.selling_plan = Number(planId);
      return item;
    });

    this.dom.cta.classList.add("is-loading");
    this.dom.cta.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () {
        // don't navigate — let the theme cart drawer (UpCart) open. Reset the
        // builder so a fresh bundle can be built, and nudge the drawer to refresh.
        self.selections = {};
        self.dom.cta.classList.remove("is-loading");
        self.afterChange();
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
      })
      .catch(function (err) {
        console.error("[build-a-box] cart", err);
        self.dom.cta.classList.remove("is-loading");
        self.renderCTA();
        alert((err && err.description) || "Could not add bundle to cart. Please try again.");
      });
  };

  function init() {
    document.querySelectorAll("[data-bab]").forEach(function (root) {
      if (root._babInit) return;
      root._babInit = true;
      new BuildABox(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
